import React from 'react'
import { Route, Routes, useLocation, NavLink } from 'react-router-dom'

import { Input, InputGroup } from 'rsuite'

import Icon from '@mdi/react'
import { mdiFilterOutline } from '@mdi/js'

import { Divider, IconButton } from '@mui/material'
import HighlightOffOutlinedIcon from '@mui/icons-material/HighlightOffOutlined'

import Empty from '../../_ui/empty'
import empty from './../../../img/empty_documents.svg'
import selected from './../../../img/selected_documents.svg'
import { BootstrapTooltip } from '../../_ui/tooltip'
import css from './portfolio.module.scss'
import StudentsContainer from './students/studentsContainer'


const Portfolio = (props: any) => {
    interface CustomizedState {
        oid: string,
        Name: string,
        Year: number
    }

    const location = useLocation()
    const url = location.state as CustomizedState
    
    return (
        <div className={css.main}>
            <div className={css.header}>
                Портфолио студентов
            </div>

            <Divider orientation="horizontal" variant="middle" flexItem sx={{ m: "0 0" }} />

            <div className={css.body}>
                <div className={css.bodyPanel}>
                    <div className={css.bodyPanelNavbar}>
                        <div className={css.thead}>
                            <div>Группа ({props.groupsList.length})</div>
                            <div style={{ textAlign: "center" }}>Год</div>
                        </div>

                        <div className={css.tfilter}>
                            <div>
                                <InputGroup inside disabled={props.groupsList.length ? false : true}>
                                    <InputGroup.Addon>
                                        <Icon path={mdiFilterOutline} size={1} style={{ margin: "-4px 0 0 -6px" }} />
                                    </InputGroup.Addon>

                                    <Input type="text" size="md" placeholder="Группа..."
                                        autoComplete="off" style={{ paddingRight: "40px" }}
                                        value={props.getFilterGroupName}
                                        onChange={value => props.setFilterGroupName(value)}
                                    />

                                    {props.getFilterGroupName &&
                                        <InputGroup.Addon onClick={() => props.setFilterGroupName('')} style={{ margin: "-7px -7px 0 0" }}>
                                            <BootstrapTooltip title="Очистить" placement="bottom" arrow>
                                                <IconButton size="small" sx={{ color: "#5763b3", m: "auto 0" }}>
                                                    <HighlightOffOutlinedIcon sx={{ fontSize: 18 }} />
                                                </IconButton>
                                            </BootstrapTooltip>
                                        </InputGroup.Addon>
                                    }
                                </InputGroup>
                            </div>

                            <div>
                                <InputGroup inside disabled={props.groupsList.length ? false : true}>
                                    <InputGroup.Addon>
                                        <Icon path={mdiFilterOutline} size={1} style={{ margin: "-4px 0 0 -6px" }} />
                                    </InputGroup.Addon>

                                    <Input type="text" size="md" placeholder="Год..."
                                        autoComplete="off" style={{ paddingRight: "40px" }}
                                        value={props.getFilterGroupYear}
                                        onChange={value => props.setFilterGroupYear(value)}
                                    />

                                    {props.getFilterGroupYear &&
                                        <InputGroup.Addon onClick={() => props.setFilterGroupYear('')} style={{ margin: "-7px -7px 0 0" }}>
                                            <BootstrapTooltip title="Очистить" placement="bottom" arrow>
                                                <IconButton size="small" sx={{ color: "#5763b3", m: "auto 0" }}>
                                                    <HighlightOffOutlinedIcon sx={{ fontSize: 18 }} />
                                                </IconButton>
                                            </BootstrapTooltip>
                                        </InputGroup.Addon>
                                    }
                                </InputGroup>
                            </div>
                        </div>

                        <div className={css.tbody}>
                            {!props.groupsList.length
                                ? <Empty image={empty} description="Данные отсутствуют" />
                                : props.groupsList.filter((val: any) => {
                                    let stringReturn

                                    let groupName = val.Name.toLowerCase().includes(props.getFilterGroupName.toLowerCase())
                                    let groupYear = val.Year.toString().toLowerCase().includes(props.getFilterGroupYear.toLowerCase())

                                    if (groupName && groupYear) {
                                        stringReturn = val
                                    }

                                    return stringReturn
                                }).map((group: any) => {
                                    return (
                                        <NavLink to={`/main/portfolio/group=${group.oid}`}
                                            key={group.oid} state={group}
                                            className={({ isActive }) => isActive ? `${css.trowActive}` : `${css.trow}`}>

                                            <div>{group.Name}</div>
                                            <div style={{ textAlign: "center" }}>{group.Year}</div>
                                        </NavLink>
                                    )
                                })
                            }
                        </div>
                    </div>
                </div>
                
                <div className={css.bodyContent}>
                    <Routes>
                        <Route path="/" element={<Empty image={selected} description="Необходимо выбрать группу из списка" />} />
                        <Route path={url ? `/group=${url.oid}` : ''} element={<StudentsContainer />} />
                    </Routes>
                </div>
            </div>
        </div>
    )
}

export default Portfolio